import { Tabs } from "@finanedi.es/storybook"
import { postEnviarInvitacionGestionadaAsesoria } from "api/EmpresaGestionadaAsesoria.service"
import notification from "common/utils/notification"
import { Form, FormikProps, withFormik } from "formik"
import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"
import MasiveFormInvitacion from "./Components/MasiveForm/MasiveFormEmpresasGestionadas"
import SimpleFormInvitacion from "./Components/SimpleForm/SimpleFormEmpresasGestionadas"
import {
  FormValues,
  SetFieldValueFunction,
  adapterMasiveAsesoria,
  adapterSimpleAsesoria,
} from "./constant"

interface FormProps {
  onHide: () => void
  t: TFunction
}

interface FormInvitacionesProps {
  values: FormValues
  setFieldValue: SetFieldValueFunction
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: $TSMigrationFixMe
  onHide: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resetForm: $TSMigrationFixMe
  handleSubmit: () => void
}

const FormInvitarEmpresasGestionadasNew: React.FC<
  FormProps & FormikProps<FormValues>
> = ({
  values,
  setFieldValue,
  errors,
  onHide,
  resetForm,
  handleSubmit,
}: FormInvitacionesProps) => {
  const { t } = useTranslation()

  return (
    <Form>
      <Tabs
        tabs={[
          {
            element: (
              <span
                key='simpleTab'
                className={`tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-px-6 ${
                  values.tabSelected === 0 ? "!tw-text-text" : ""
                }`}
                onClick={() => {
                  setFieldValue("tabSelected", 0, false)
                  setFieldValue("showModalPolicitySimple", false, false)
                }}
              >
                {t("empresasGestionadas.modal.simpleSend")}
              </span>
            ),
            disabled: false,
          },
          {
            element: (
              <span
                key='masiveTab'
                className={`tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-px-6 ${
                  values.tabSelected === 1 ? "!tw-text-text" : ""
                }`}
                onClick={() => {
                  setFieldValue("tabSelected", 1, false)
                  setFieldValue("showModalPoliciyMasive", false, false)
                }}
              >
                {t("empresasGestionadas.modal.masiveSend")}
              </span>
            ),
            disabled: false,
          },
        ]}
        tabSelected={values.tabSelected}
        tabsContainerTailwind='!tw-bg-transparent tw-flex tw-flex-row tw-items-center tw-mb-4 !tw-text-text'
        tabsTailwind='tw-cursor-pointer tw-select-none tw-text-primary-50 tw-h-16 tw-flex tw-items-center tw-text-lg'
        tabsActiveTailwind='tw-cursor-pointer tw-select-none tw-text-primary tw-font-medium tw-border-0 tw-border-b-4 tw-border-solid tw-border-primary tw-h-16 tw-flex tw-items-center tw-text-lg'
        tabTitle={[]}
        tabChild={[
          [
            <SimpleFormInvitacion
              key='simple'
              values={values}
              errors={errors}
              setFieldValue={setFieldValue}
            />,
          ],
          [
            <MasiveFormInvitacion
              key='masive'
              values={values}
              errors={errors}
              setFieldValue={setFieldValue}
            />,
          ],
        ]}
      />
      <div className='tw-w-full tw-flex tw-flex-row tw-justify-end'>
        <div
          className='tw-h-10 tw-w-fit tw-rounded tw-cursor-pointer tw-flex tw-px-6 tw-items-center tw-text-base'
          onClick={() => {
            resetForm()
            onHide()
          }}
        >
          {t("empresasGestionadas.modal.cancel")}
        </div>
        <div
          className='tw-h-10 tw-w-fit tw-rounded tw-cursor-pointer tw-bg-primary tw-text-simple-10 tw-flex tw-px-6 tw-items-center tw-text-base'
          onClick={() => handleSubmit()}
        >
          {t("empresasGestionadas.modal.sendInvitacion")}
        </div>
      </div>
    </Form>
  )
}

const FormInvitarEmpresasGestionadas = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => ({
    tabSelected: 0,
    simple: [
      {
        email: null,
        nif: null,
        razonSocial: null,
      },
    ],
    masive: {
      archive: null,
      options: {
        nif: null,
        razonSocial: null,
        email: null,
      },
    },
    policitySimple: false,
    policityMasive: false,
    showModalPolicitySimple: false,
    showModalPoliciyMasive: false,
  }),
  validationSchema: ({ t }: FormProps) => {
    return Yup.object().shape({
      tabSelected: Yup.number().required(),
      simple: Yup.array().when("tabSelected", {
        is: 0,
        then: Yup.array()
          .of(
            Yup.object().shape({
              email: Yup.string()
                .email(
                  `${t("empresasGestionadas.modal.simple.errors.typeEmail")}`
                )
                .nullable()
                .test(
                  "email",
                  `${t("empresasGestionadas.modal.simple.errors.email")}`,
                  (value, context) => {
                    const { nif, razonSocial } = context.parent
                    if (value) {
                      return true
                    }
                    if ((nif || razonSocial) && !value) {
                      return false
                    }
                    return true
                  }
                ),
              nif: Yup.string()
                .nullable()
                .test(
                  "nif",
                  `${t("empresasGestionadas.modal.simple.errors.nif")}`,
                  (value, context) => {
                    const { email, razonSocial } = context.parent
                    if (value) {
                      return true
                    }
                    if ((email || razonSocial) && !value) {
                      return false
                    }
                    return true
                  }
                ),
              razonSocial: Yup.string()
                .nullable()
                .test(
                  "razonSocial",
                  `${t("empresasGestionadas.modal.simple.errors.razonSocial")}`,
                  (value, context) => {
                    const { email, nif } = context.parent
                    if (value) {
                      return true
                    }
                    if ((email || nif) && !value) {
                      return false
                    }
                    return true
                  }
                ),
            })
          )
          .test(
            "optionsTest",
            `Debe completar al menos un elemento`,
            (value) => {
              return Boolean(
                value?.find(
                  (element) =>
                    element.email !== null &&
                    element.nif !== null &&
                    element.razonSocial !== null
                )
              )
            }
          ),
      }),
      masive: Yup.object().when("tabSelected", {
        is: 1,
        then: Yup.object().shape({
          archive: Yup.array().nullable().required(),
          options: Yup.object()
            .shape({
              nif: Yup.string().nullable().required(),
              razonSocial: Yup.string().nullable().required(),
              email: Yup.string().nullable().required(),
            })
            .nullable(),
        }),
      }),
      policitySimple: Yup.boolean().when("tabSelected", {
        is: 0,
        then: Yup.boolean().test(
          "is-true",
          `${t("empresasGestionadas.modal.simple.errors.policity")}`,
          (value) => value === true
        ),
      }),
      policityMasive: Yup.boolean().when("tabSelected", {
        is: 1,
        then: Yup.boolean().test(
          "is-true",
          `${t("empresasGestionadas.modal.simple.errors.policity")}`,
          (value) => value === true
        ),
      }),
    })
  },
  validateOnChange: false,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: async (values, { resetForm, props: { onHide, t } }) => {
    try {
      if (
        values.tabSelected === 0 &&
        values.simple.length === 1 &&
        values.simple[0].email === null &&
        values.simple[0].nif === null &&
        values.simple[0].razonSocial === null
      ) {
        return
      }

      const { status }: { status: number } =
        await postEnviarInvitacionGestionadaAsesoria(
          values.tabSelected === 0
            ? adapterSimpleAsesoria(values)
            : adapterMasiveAsesoria(values)
        )

      if (status === 200) {
        notification.success({
          body: `${t("empresasGestionadas.modal.statusOk")}`,
        })
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    } finally {
      resetForm()
      onHide()
    }
  },
})(FormInvitarEmpresasGestionadasNew)

export default FormInvitarEmpresasGestionadas
